import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { domainAccessOptions } from 'reactApp/components/SharingNewBiz/SharingNew.constants';
import { DomainAccess } from 'reactApp/components/SharingNewBiz/SharingNew.types';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { getIntraDomainShare } from 'reactApp/modules/home/home.selectors';

import { DomesticDropdownTemplate } from '../DomesticDropdownTemplate/DomesticDropdownTemplate';
import type { DomesticProps } from './DomesticDropdown.types';
import { useDomestic } from './hooks/useDomestic';

const getModifiedOptionsForIntraDomainShareFeature = (options: typeof domainAccessOptions) => {
    const { [DomainAccess.EXTERNAL]: external, ...rest } = options;
    return {
        [DomainAccess.EXTERNAL]: {
            ...external,
            disabled: true,
        },
        ...rest,
    };
};

export const DomesticDropdown: React.FC<DomesticProps> = ({
    storage,
    item,
    isPublicPasswordEnabled,
    isWeblinkOpened,
    isPersonalAccessSharing,
    formProps,
    pin,
    onActionClick,
    xrayItemType,
}) => {
    const isPhone = EnvironmentSelectors.isPhone();
    const isFolder = item?.isFolder;
    const isSupportIntraDomainShare = useSelector(getIntraDomainShare);
    const onpremOrFolderDomainAccess = item?.weblinkDomestic || isSupportIntraDomainShare ? DomainAccess.DOMESTIC : DomainAccess.EXTERNAL;
    const weblinkDomainAccess = item && 'weblinkDomainAccess' in item ? (item.weblinkDomainAccess as DomainAccess) : DomainAccess.DOMESTIC;
    const domainAccess = !isPersonalAccessSharing ? onpremOrFolderDomainAccess : weblinkDomainAccess;
    const checked = !isWeblinkOpened ? DomainAccess.EMAIL_LIST_ACCESS : domainAccess;

    const modifiedDomainAccessOptions = useMemo(() => {
        if (isSupportIntraDomainShare) {
            return getModifiedOptionsForIntraDomainShareFeature(domainAccessOptions);
        }
        return domainAccessOptions;
    }, [isSupportIntraDomainShare]);

    const { renderDropdownMenu, handleUpdateDomestic } = useDomestic({
        checked,
        item,
        storage,
        isWeblinkOpened,
        onActionClick,
        formProps,
        pin,
        isPublicPasswordEnabled,
        domainAccessOptions: modifiedDomainAccessOptions,
        isPersonalAccessSharing,
        xrayItemType,
    });

    return (
        <DomesticDropdownTemplate
            checked={checked}
            accessText={isFolder ? 'Папка доступна по ссылке' : 'Файл доступен по ссылке'}
            isPhone={isPhone}
            renderDomesticDropdown={renderDropdownMenu}
            handleUpdateDomestic={handleUpdateDomestic}
        />
    );
};
